import { EMAIL_VALIDATOR } from '@farmnet/validators';

angular
  .module('cfn')
  .controller('emailChangeConfirmPopupController', emailChangeConfirmPopupController);

emailChangeConfirmPopupController.$inject = [
  '$rootScope',
  '$location',
  'changeEmailService',
  'i18nFilter'
];

function emailChangeConfirmPopupController(
  $rootScope,
  $location,
  changeEmailService,
  i18nFilter
) {
  var vm = this;
  
  vm.currentEmail = undefined;
  vm.isPopupShowing = false;
  vm.formData = {
    newEmail: '',
    newEmailConfirm: '',
  };
  
  vm.closePopup = closePopup;
  vm.hasEmailMismatch = hasEmailMismatch;
  vm.resendConfirmationMail = resendConfirmationMail;
  vm.sendNewChangeRequest = sendNewChangeRequest;
  vm.emailPattern = EMAIL_VALIDATOR;
  
  init();
  
  function init() {
    if (app.credentials.loggedIn && !$location.url().includes('/landing/landsberg')) {
      changeEmailService
        .getLatestEmailChange()
        .then(
          function (latestChange) {
            if (latestChange.data &&
                latestChange.data.email &&
                latestChange.data.status === 'OPEN') {
              vm.currentEmail = latestChange.data.email;
              
              if (localStorage.getItem('showEmailConfirmationPopup') === 'true') {
                vm.isPopupShowing = true;
              } else {
                localStorage.removeItem('showEmailConfirmationPopup');
              }
            }
          },
          function (error) {
            console.error('ERROR retrieving email changes:', error);
          }
        );
    }
  }
  
  function closePopup() {
    vm.isPopupShowing = false;
    localStorage.removeItem('showEmailConfirmationPopup');
  }
  
  function hasEmailMismatch() {
    return this.formData.newEmail !==
      this.formData.newEmailConfirm;
  };
  
  function resendConfirmationMail() {
    if (vm.currentEmail) {
      changeEmailService.resendConfirmationMail(
        vm.currentEmail
      ).then(
        function (response) {
          vm.closePopup();
          
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.admin.settings.changeEmail.changeSuccessMessage',
              'Wir haben Ihnen eine Bestätigungsmail an Ihre neue E-Mail-Adresse gesendet.'
            ),
            'success'
          );
        },
        function (error) {
          console.log('ERROR:', error);
          
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.admin.settings.changeEmail.resendErrorMessage',
              'Beim erneuten Senden der Bestätigungsmail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
            ),
            'error'
          );
        }
      );
    }
  }
  
  function sendNewChangeRequest() {
    changeEmailService.updateEmailAddress(
      vm.formData.newEmail
    ).then(
      function (response) {
        vm.formData.newEmail = '';
        vm.formData.newEmailConfirm = '';
        vm.closePopup();
        
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter(
            'fe.admin.settings.changeEmail.changeSuccessMessage',
            'Wir haben Ihnen eine Bestätigungsmail an Ihre neue E-Mail-Adresse gesendet.'
          ),
          'success'
        );
      },
      function (error) {
        console.log('ERROR:', error);
        
        $rootScope.alertController.addTemporaryAlert(
          i18nFilter(
            'fe.admin.settings.changeEmail.changeErrorMessage',
            'Beim Ändern Ihrer E-Mail-Adresse ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
          ),
          'error'
        );
      }
    );
  }
}
